
    import {Options, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';

    type StrokeProperties = {
        'stroke-dasharray': string;
        'stroke-dashoffset': string;
    };
    const defaultStrokeProps = {
        'stroke-dasharray': '0',
        'stroke-dashoffset': '0',
    };

    @Options({})
    export default class TagCounterIndicator extends Vue {
        @Prop({type: Array, required: true})
        tags!: Tag[];
        @Prop({type: Number, required: false, default: 4})
        counterForCreation!: number;
        @Prop({type: Number, required: false, default: 7})
        counterForCompletion!: number;
        @Prop({type: Number, required: true})
        maxTagCount!: number;
        $refs!: {
            progressCircleCreation: SVGCircleElement;
            progressCircleCompletion: SVGCircleElement;
        };
        strokePropsCreation: StrokeProperties = Object.assign({}, defaultStrokeProps);
        strokePropsCompletion: StrokeProperties = Object.assign({}, defaultStrokeProps);

        @Watch('tags', {deep: true})
        computeGauge(): void {
            let radius = this.$refs.progressCircleCreation.r.baseVal.value;
            let circumference = radius * 2 * Math.PI;

            if (!this.reachedLimitForCreation) {
                const percent = (this.tags.length * 100) / this.counterForCreation;
                const offset = circumference - (percent / 100) * circumference;
                this.strokePropsCreation['stroke-dasharray'] = `${circumference} ${circumference}`;
                this.strokePropsCreation['stroke-dashoffset'] = `${offset}`;
            }

            if (this.reachedLimitForCreation) {
                this.strokePropsCreation['stroke-dasharray'] = `${circumference} ${circumference}`;
                this.strokePropsCreation['stroke-dashoffset'] = `0`;

                radius = this.$refs.progressCircleCompletion.r.baseVal.value;
                circumference = radius * 2 * Math.PI;

                let percent: number;
                if (this.tags.length <= this.counterForCompletion) {
                    percent = ((this.tags.length - this.counterForCreation) * 100) / (this.counterForCompletion - this.counterForCreation);
                } else {
                    percent = 100;
                }
                const offset = circumference - (percent / 100) * circumference;
                this.strokePropsCompletion['stroke-dasharray'] = `${circumference} ${circumference}`;
                this.strokePropsCompletion['stroke-dashoffset'] = `${offset}`;
            }
        }

        get leftTagsCountForCreation(): number {
            return this.counterForCreation - this.tags.length;
        }

        get reachedLimitForCreation(): boolean {
            return this.leftTagsCountForCreation <= 0;
        }

        get leftTagsCountForCompletion(): number {
            return this.counterForCompletion - this.tags.length;
        }

        get reachedLimitForCompletion(): boolean {
            return this.leftTagsCountForCompletion <= 0;
        }

        get hasTag(): boolean {
            return this.tags.length > 0;
        }
    }
